import { Component } from '@angular/core'
import { appConfig } from '../../../../brands/_current/config/app-config'
import { LoginService } from '../../../login/shared/login.service'

@Component({
  selector: 'app-closing-account-page',
  templateUrl: './closing-account-page.component.html',
  styleUrls: ['./closing-account-page.component.scss'],
})
export class ClosingAccountPageComponent {
  public brandName: string
  public helplineNumber: string
  public label = $localize`Puoi riattivare il tuo account oppure crearne uno nuovo per accedere nuovamente ai servizi`

  constructor(private readonly loginService: LoginService) {
    this.brandName = appConfig.core.brandName
    this.helplineNumber = appConfig.core.helplineNumber
  }

  onBackToLoginPageButton() {
    this.loginService.backToLogin().subscribe()
  }
}
